<template>
  <div class="horizontal-bar-chart">
    <label>{{chartTitle}}</label>
    <div class="chart-container">
        <canvas ref="canvas"></canvas>
        <div class = 'labels-container' >
          <div class="chart-label" v-for="(dataset, index) in localChartData.datasets" 
             :key="index" 
             :style="{left: dataset.labelPosition + '%'}">
            <span class="label" style="text-align: center;">{{ dataset.label }}</span>
            <span class="sublabel" style="text-align: center;">{{ sublabels[index] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HorizontalBar } from 'vue-chartjs';
import { isEmpty, isEqual, cloneDeep } from "lodash";
import colors from './chartcolors.js';

export default {
  extends: HorizontalBar,
  name:'HorizontalBarChart',
  props: {
      chartData: {
          required: true,
          type: Object
      },
      chartTitle: {
          required: true,
          type: String
      },
      category: {
        required: false,
        type: String
      },
  },
 computed: {
  sublabels() {
    // Find the correct dataset based on this.category
    const datasets = this.chartData.datasets[this.category];

    // Generate sublabels from the values in the correct dataset
    return datasets.map(dataset => {
      const value = dataset.data[0];
      return this.category === 'percent' ? `(${value}%)` : `(${value})`;
    });
  }
},
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              min: 0,
              max: 100,
              display:false, 
            },
            gridLines: {
              display:false,
              drawBorder:false
            }
          }],
          yAxes: [{
            stacked: true,
            gridLines: {
              display:false,
              drawBorder:false
            },
            categoryPercentage: 1, // adjust this value to change the thickness of the bar
            barPercentage: 1
          }]
        },
        animation:{
          onComplete:function(){
           let chartInstance = this.chart;
           let ctx = chartInstance.ctx;
           ctx.textAlign = "center";
           ctx.textBaseline = "middle";
           ctx.font = "10px Arial";
        }
      },
    },
      localChartData: {
        labels: [],
        datasets: [{ data: [] }]
      },
    }  
  },
  mounted() {
    this.$nextTick(function () {
      this.paintChart();
    })
  },


  methods: {

    paintChart() {
        let dataset;
        if (this.category && this.chartData.datasets[this.category]) {
          dataset = this.chartData.datasets[this.category];
        } else {
          let firstCategory = Object.keys(this.chartData.datasets)[0];
          dataset = this.chartData.datasets[firstCategory];
        }
        this.localChartData = { datasets: cloneDeep(dataset) };
        this.calculateLabelPositions();
        this.addColors();
        this.renderChart(this.localChartData, this.options);
    },
    addColors() {
      // Get the context of the canvas
      if (this.$refs.canvas == undefined) return; // sometimes the old chart.js component croaks - need to update to 5.0 but will need to update vue
      let ctx = this.$refs.canvas.getContext('2d');

      // Randomly select colors for each dataset
      let selectedColors = colors.sort(() => 0.5 - Math.random()).slice(0, this.localChartData.datasets.length);

      // Apply gradient to each dataset
      this.localChartData.datasets.forEach((dataset, i) => {
        // Create a linear gradient
        let color = selectedColors[i];
        let gradient = ctx.createLinearGradient(0, 0, 400, 0); 
        gradient.addColorStop(0, color.start); // Start color
        gradient.addColorStop(1, color.stop); // End color

        // Assign the gradient to the backgroundColor property of your dataset
        //dataset.backgroundColor = gradient;
        this.$set(dataset, 'backgroundColor', gradient);
      });

    },

    calculateLabelPositions() {
      let total = this.localChartData.datasets.reduce((sum, dataset) => sum + dataset.data[0], 0);
      let previousValue = 0;
      this.localChartData.datasets.forEach(dataset => {
        let value = dataset.data[0];
        let start = (previousValue / total) * 100; // start of the segment in percentage
        let end = ((previousValue + value) / total) * 100; // end of the segment in percentage
        this.$set(dataset, 'labelPosition', (start + end) / 2);
        previousValue += value; // update total value for next label
      });
    }
  },
  watch: {
      chartData: {
            deep: true,
            handler(to, from) { 
                //if (!isEqual(to, from)) { 
                   this.paintChart();
                //}
            }
      },
      category(to, from) { //console.log(to, from);
        if (to === undefined) return;
        else if (to != from) this.paintChart();
      }
  }
}
</script>
<style lang="scss" scoped>
.chart-container {
  position: relative;
  height:50px;
  margin-top:30px; // to move the line chart a little down in the chart-box;
}

.labels-container {
  position: absolute;
  width: 100%;
  height:50px; // same as chart container
  top:0;
  display:flex;
  align-items:center;
}

.chart-label {
  position: absolute;
  top: 15%;
  display: flex;
    flex-direction: column;
    justify-content: center;
}
label {
  font-size:12px;
  font-weight:500;
}
.label {
  font-size:11px;
  font-weight:500;
  margin-bottom:0px;
}
.sublabel {
  font-size:10px;
  margin-top:2px;
}

</style>






